import { formatCurrency, formatNumber } from "utils/tools"

// Whole-dollar amounts, as the dashboard shows them.
export const money = (value: number | null | undefined) => formatCurrency(value ?? 0, "CAD", 0)

// Amounts with cents ("$1,804,779.20").
export const exactMoney = (value: number | null | undefined) => formatCurrency(value ?? 0, "CAD", 2)

// Short amounts as Power BI shows them: "$1.8M", "-$11.7M", "$656.2K".
export const compactMoney = (value: number | null | undefined) => {
    const n = value ?? 0
    const abs = Math.abs(n)
    const sign = n < 0 ? "-" : ""
    if (abs >= 1e9) return `${sign}$${(abs / 1e9).toFixed(1)}B`
    if (abs >= 1e6) return `${sign}$${(abs / 1e6).toFixed(1)}M`
    if (abs >= 1e3) return `${sign}$${(abs / 1e3).toFixed(1)}K`
    return `${sign}$${abs.toFixed(0)}`
}

export const percent =(ratio: number | null | undefined, decimals = 1) =>
    ratio === null || ratio === undefined ? "—" : `${formatNumber(ratio * 100, decimals)}%`

// "Sep-2026" from an ISO date. Read in UTC so a date stored at midnight doesn't slip a month.
export const monthLabel = (iso: string | null | undefined): string => {
    if (!iso) return "—"
    const d = new Date(iso)
    if (isNaN(d.getTime())) return "—"
    const month = d.toLocaleString("en-CA", { month: "short", timeZone: "UTC" }).replace(".", "")
    return `${month}-${d.getUTCFullYear()}`
}
